import * as Slider from '@radix-ui/react-slider'
import styled from 'styled-components'

export const Section = styled.div`
  margin-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 12px;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.75rem;
  font-weight: 500;
  margin-bottom: 8px;
`

export const Content = styled.div<{ $isOpen: boolean }>`
  max-height: ${({ $isOpen }) => ($isOpen ? '600px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease;
`

export const Field = styled.div`
  margin-bottom: 12px;
`

export const Label = styled.div`
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 4px;
`

export const SubHeader = styled.div`
  font-size: 0.8rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  margin: 12px 0;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.23);
`

const baseInputStyles = `
  width: 100%;
  min-height: 32px;
  padding: 6px 12px;
  font-size: 0.875rem;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);

  &:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.5);
  }
`

export const Select = styled.select`
  ${baseInputStyles}
  cursor: pointer;

  option {
    background-color: rgb(30, 30, 30);
  }
`

export const Button = styled.button<{
  $variant?: 'primary' | 'danger' | 'default'
}>`
  ${baseInputStyles}
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  ${({ $variant }) => {
    if ($variant === 'primary')
      return `
      background-color: rgba(59, 130, 246, 0.8);
      border-color: rgba(59, 130, 246, 1);
      &:hover:not(:disabled) { background-color: rgba(59, 130, 246, 1); }
    `
    if ($variant === 'danger')
      return `
      background-color: rgba(220, 38, 38, 0.8);
      border-color: rgba(220, 38, 38, 1);
      &:hover:not(:disabled) { background-color: rgba(220, 38, 38, 1); }
    `
    return `&:hover:not(:disabled) { background-color: rgba(255, 255, 255, 0.2); }`
  }}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const DataItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  margin-bottom: 8px;
  font-size: 0.75rem;
  gap: 8px;
`

export const DataItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

export const DataInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 4px;
`

export const SmallButton = styled.button<{ $variant?: 'primary' | 'danger' }>`
  padding: 2px 8px;
  font-size: 0.7rem;
  color: white;
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;

  ${({ $variant }) => {
    if ($variant === 'primary')
      return `
      background: rgba(59, 130, 246, 0.8);
      border: 1px solid rgba(59, 130, 246, 1);
      &:hover { background: rgba(59, 130, 246, 1); }
    `
    return `
      background: rgba(220, 38, 38, 0.8);
      border: 1px solid rgba(220, 38, 38, 1);
      &:hover { background: rgba(220, 38, 38, 1); }
    `
  }}
`

export const OpacitySliderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`

export const OpacityLabel = styled.div`
  font-size: 0.7rem;
  color: rgba(255, 255, 255, 0.7);
  min-width: 50px;
`

export const OpacitySliderRoot = styled(Slider.Root)`
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: none;
  height: 20px;
  flex: 1;
`

export const OpacitySliderTrack = styled(Slider.Track)`
  background-color: rgba(255, 255, 255, 0.15);
  position: relative;
  border-radius: 9999px;
  height: 4px;
  flex: 1;
`

export const OpacitySliderRange = styled(Slider.Range)`
  position: absolute;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 9999px;
  height: 100%;
`

export const OpacitySliderThumb = styled(Slider.Thumb)`
  display: block;
  width: 12px;
  height: 12px;
  background-color: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.95);
    transform: scale(1.1);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);
  }
`

export const OpacityValue = styled.div`
  min-width: 2.5rem;
  font-size: 0.7rem;
  text-align: right;
  color: rgba(255, 255, 255, 0.9);
`
